export default __webpack_public_path__ + "static/media/UploadImagingFile.7a0dc92a.svg";